import React, { FC } from 'react';
import { CarTitleProps } from './index';

export const CarTitleTemplate: FC<CarTitleProps> = ({ className, title }) => {
    return (
        <div className={className}>
            <span className="left" />
            <span className="center">{title}</span>
            <span className="right" />
        </div>
    );
};
